import React from "react";
import { useContent } from "@/lib/content";

/**
 * Slowly drifting colored blur blob used for ambient background motion.
 *
 * Uses CSS individual transform properties (`translate`, `scale`) in the
 * keyframes so it can coexist with Tailwind utilities like `-translate-x-1/2`
 * (which sets `transform: translate(...)`) without them clobbering each other.
 *
 * Speed is controlled by branding.blob_animation_speed_seconds (lower = faster).
 * Honors prefers-reduced-motion via CSS.
 */
export default function AnimatedBlob({ className = "", style = {}, delay = 0 }) {
  const { branding = {} } = useContent();
  const duration = Math.max(1.5, Number(branding.blob_animation_speed_seconds) || 24);
  return (
    <div
      className={`shape-blob blob-anim ${className}`}
      style={{ ...style, animationDuration: `${duration}s`, animationDelay: `${delay}s` }}
      aria-hidden="true"
    />
  );
}
